export default "__VITE_ASSET__54da5869__"